
import * as Website from './Config/Website.js';

import * as Common from './Page/Common/App.js';
import * as Home from './Page/Home/App.js';

const page = Website.status.page.toLowerCase();


Website.event.init();


// COMMON INIT
window.addEventListener("DOMContentLoaded", () => Common.preinit());
Common.init();
window.addEventListener("load", () => Common.load());
window.addEventListener("resize", () => Common.resize());
window.addEventListener('widthchange', () => Common.resizeW());
window.addEventListener("scroll", () => Common.scroll());
window.addEventListener("orientationchange", () => Common.resize());
window.addEventListener("orientationchange", () => Common.scroll());


switch(page) {
  case "home": 
    Home.init();
    window.addEventListener('load', () => Home.load());
    window.addEventListener('resize', () => Home.resize());
    window.addEventListener('widthchange', () => Home.resizeW());
    window.addEventListener('scroll', () => Home.scroll());
    window.addEventListener("orientationchange", () => Home.resize());
    window.addEventListener("orientationchange", () => Home.scroll());
  break;
}